import React  from 'react'
import {Link} from 'react-router-dom';
// import Img1 from '../../img/darck/jogos/capa_1.png';
// import Img2 from '../../img/darck/jogos/capa_2.png';

export default class Jogos extends React.Component {

    render() {
        return (
            <div>
            <div className="container-bg">

                <div className="titulo-pages topo_conteudo">
                    <span>Jogos</span>
                </div>
                    <div className="row">
                        <div className="conteudo-jogos">
                            <div className="col-xs-6 col-md-6">
                                <Link to="/home/jogo/1"  className="thumbnail">
                                    {/* <img alt="Fruit Ninja" data-src="holder.js/100%x180" src={Img2} data-holder-rendered="true"></img> */}
                                </Link>
                            </div>
                            <div className="col-xs-6 col-md-6">
                                <Link to="/home/jogo/2"  className="thumbnail">
                                    {/* <img alt="Fruit Ninja" data-src="holder.js/100%x180" src={Img1} data-holder-rendered="true"></img> */}
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>      
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/jogos/jogosG.js